import { useCallback, useEffect, useState } from 'react';

interface TireLifeCounterProps {
  children: ({ value }: { value: number | string }) => React.ReactElement;
  countTo: number;
  duration?: number;
  isSliderActive?: boolean;
  isWholeNum?: boolean;
  shouldRoundDown?: boolean;
  start?: boolean;
  suffix?: string;
}

function TireLifeCounter(props: TireLifeCounterProps) {
  const {
    children,
    countTo,
    duration = 1000,
    isSliderActive = false,
    isWholeNum = false,
    shouldRoundDown = false,
    start = false,
    suffix = ''
  } = props;

  const [count, setCount] = useState(0);
  const [isMounted, setIsMounted] = useState(false);

  const incrementCount = useCallback(() => {
    const interval = 75;
    const steps = duration / interval;
    let incrementBy = countTo / steps;

    if (isMounted) {
      return setCount(countTo);
    }

    if (count + incrementBy > countTo) {
      incrementBy = countTo - count;
      setIsMounted(true);
    }

    if (!isNaN(countTo) && count < countTo && !isSliderActive && start) {
      setTimeout(() => setCount(count + incrementBy), interval);
    }
  }, [count, countTo, duration, isMounted, isSliderActive, start]);

  useEffect(() => {
    incrementCount();
  }, [count, incrementCount]);

  useEffect(
    () => () => {
      setIsMounted(false);
    },
    []
  );

  let value: number | string = Math.round(count * 10) / 10;

  if (isWholeNum) {
    value = Math.round(count);
  }

  if (shouldRoundDown) {
    value = Math.floor(count);
  }

  if (suffix) {
    value = value + suffix;
  }

  if (isNaN(countTo)) {
    value = countTo;
  }

  return children({ value });
}

export default TireLifeCounter;
